var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 447,
    height: 62,
    viewBox: "0 0 447 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M402.594 30.752L446.918 0V61.5039L402.594 30.752Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352.269 30.752L396.594 0V61.5039L352.269 30.752Z",
    fill: "#0A0F40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M301.945 30.752L346.27 0V61.5039L301.945 30.752Z",
    fill: "#152080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M251.621 30.7519L295.945 -6.10352e-05V61.5039L251.621 30.7519Z",
    fill: "#1F39BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.297 30.7519L245.621 -6.10352e-05V61.5039L201.297 30.7519Z",
    fill: "#2958FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.973 30.7519L195.297 -6.10352e-05V61.5039L150.973 30.7519Z",
    fill: "#5484FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.648 30.7519L144.973 -6.10352e-05V61.5039L100.648 30.7519Z",
    fill: "#7FC2FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3242 30.7519L94.6484 -6.10352e-05V61.5039L50.3242 30.7519Z",
    fill: "#A9EAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90735e-05 30.7519L44.3243 -6.10352e-05V61.5039L1.90735e-05 30.7519Z",
    fill: "#D4FFFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowlist);
export default __webpack_public_path__ + "static/media/arrowlist.e916b6a05806409f690428f52a9c0d38.svg";
export { ForwardRef as ReactComponent };